import axios from 'axios'
import { routes } from 'config/routes'
import { useNavigate } from 'libs/router'
import { useTranslation } from 'react-i18next'
import { ResetPasswordReqBody } from '../types'
import { useToast } from 'shared/hooks'
import { useMutation } from 'libs/query'

export const useResetPasswordMutation = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const searchParams = new URLSearchParams(document.location.search)

	const {
		mutate: resetPasswordMutation,
		isPending: isResetPasswordLoading,
		isSuccess: isResetPasswordSuccess
	} = useMutation({
		mutationFn: ({ password }: ResetPasswordReqBody) => {
			const body = {
				key: searchParams.get('token'),
				password: password
			}
			// TODO: use apiRoutes
			return axios.post('/accounts/reset-password/', body)
		},
		onSuccess: () => {
			navigate(routes.login)
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		resetPasswordMutation,
		isResetPasswordLoading,
		isResetPasswordSuccess
	}
}
